import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';
import Main from 'components/main';
import css from 'static/style/dow.less';
import fontAwesome from 'rlink-lesscore/icons/font-awesome.less';
import {MediaGallery} from 'components/media-gallery';
import {DOW} from 'terms';
import DocumentTitle from 'rlink-react-document/DocumentTitle.jsx';
import DocumentOpenGraphProperty from 'rlink-react-document/DocumentOpenGraphProperty.jsx';

export default function (params, content) {
  let items = content.mediaItems.items.toJS();
  let title = 'Media';
  let image = items[0].thumbnailPath;
  if (params.slug) {
    let mediaItem = items.filter(item => (item.slug === params.slug))[0];
    title = mediaItem.title;
    image = mediaItem.thumbnailPath;
  }

  let description = <FormattedMessage
    id="ui.text.info.MEDIA_DESCRIPTION"
    defaultMessage="Dawn of War Screenshots, Wallpapers and Videos"
    description="Description of the media page." />;

  return (<Main globalSettings={content.globalSettings}>
    <DocumentTitle title="Media" site={DOW} />
    <DocumentOpenGraphProperty property="url" value="https://www.dawnofwar.com/media" />
    <DocumentOpenGraphProperty property="title" value={title} />
    <DocumentOpenGraphProperty property="description" value={description} />
    <DocumentOpenGraphProperty property="image" value={image} />
    <div key="media">
      <section className={css['media-panel']}>
        <div className={css['media-content']}>
          <h2>
            <FormattedMessage
              id="ui.label.title.MEDIA_PAGE"
              defaultMessage="media"
              description="Title of the media page." />
          </h2>
          <MediaGallery css={css}
            fontAwesome={fontAwesome}
            items={items}
            modalOpen={(typeof params !== 'undefined' && ('slug' in params)) ? params.slug : false} />
        </div>
      </section>
    </div>
  </Main>);
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/views/media.jsx